export default "__VITE_ASSET__CyX8J0nX__"